<template>
  <a-modal :maskClosable="false" :visible="value" :title="id?$t('edit')+$t('page_andon')+$t('page_andon_call_reason'):$t('create')+$t('page_andon')+$t('page_andon_call_reason')" :width="600" @cancel="onClose">
    <a-form-model :model="form" :rules="rules" ref="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('page_andon')+$t('page_andon_call_type_code')" prop="typeCode">
          <a-input disabled :placeholder="$t('common_please_input')+$t('page_andon')+$t('page_andon_call_type_code')" v-model="form.typeCode" />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_andon')+$t('page_andon_call_type')">
        <a-input disabled :placeholder="$t('common_please_input')+$t('page_andon')+$t('page_andon_call_type')" v-model="form.typeName" />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_andon')+$t('page_andon_call_reason_code')" prop="code">
        <a-input :placeholder="$t('common_please_input')+$t('page_andon')+$t('page_andon_call_reason_code')" v-model="form.code" />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_andon')+$t('page_andon_call_reason')" prop="name">
        <a-input :placeholder="$t('common_please_input')+$t('page_andon')+$t('page_andon_call_reason')" v-model="form.name" />
      </a-form-model-item>
      <a-form-model-item :label="$t('remark')">
        <a-textarea
          v-model="form.remark"
          :placeholder="$t('common_please_input')+$t('remark')"
          :auto-size="{ minRows: 2, maxRows: 6 }"
        />
      </a-form-model-item>
    </a-form-model>
    <div slot="footer">
       <a-button @click="onClose" type="default">
        {{$t('cancel')}}
      </a-button>
      <a-button @click="onReset" type="danger">
        {{$t('common_reset')}}
      </a-button>
       <a-button :loading="submitLoading" type="primary" @click="onSubmit">
        {{$t('save')}}
      </a-button>
     </div>
  </a-modal>
</template>

<script>
import {AndonReasonServiceProxy} from '@/service-proxies/app-v2/andon.service-proxies'
const andonReasonServiceProxy = new AndonReasonServiceProxy();
export default {
  props:{
    value:{
      type:Boolean,
      default:false
    },
    id:{
    },
    typeData:{
      type:Object,
      default:() => {}
    }
  },
  watch:{
    value:function(newVal,oldVal){
      if(!newVal){
        this.$refs.form.resetFields();
        this.form = {}
      }else{
        if(!this.id){
          this.form = {
            typeId:this.typeData.id,
            typeCode:this.typeData.code,
            typeName:this.typeData.name
          }
        }else{
          this.getDetail()
        }
      }
    }
  },
  methods:{
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.indexOf(input.toUpperCase()) >= 0
      );
    },
    onClose(){
      this.$emit('close',false);
    },
    getDetail(){
      if(!this.id) return;
      andonReasonServiceProxy.getAndonReason(this.id).then(res => {
        this.form = {
          typeId:this.typeData.id,
          typeCode:this.typeData.code,
          typeName:this.typeData.name,
          ...res
        }
      })
    },
    // 重置
    onReset(){
      this.$refs.form.resetFields();
      if(this.id){
        this.form = {
          id:this.id,
          typeId:this.typeData.id,
          typeCode:this.typeData.code,
          typeName:this.typeData.name
        }
      }else{
        this.form = {
          typeId:this.typeData.id,
          typeCode:this.typeData.code,
          typeName:this.typeData.name
        }
      }
    },
    // 保存
    onSubmit(){
      this.$refs.form.validate(valid => {
        if (valid) {
          if(this.id){
            this.handleUpdate();
          }else{
            this.handleAdd();
          }
        }
      });
    },
    handleAdd(){
      this.submitLoading = true;
      let data = {
        typeId:this.form.typeId,
        code:this.form.code,
        name:this.form.name,
        remark:this.form.remark
      }
      andonReasonServiceProxy.saveAndonReason(data).then(res => {
        this.submitLoading = false;
        this.$message.success(this.$t('page_tpm_check_create_success'))
        this.$emit('submit')
      }).catch(() => {
        this.submitLoading = false;
      })
    },
    handleUpdate(){
      this.submitLoading = true;
      let data = {
        typeId:this.form.typeId,
        code:this.form.code,
        id:this.form.id,
        name:this.form.name,
        remark:this.form.remark
      }
      andonReasonServiceProxy.updateAndonReason(data).then(res => {
        this.submitLoading = false;
        this.$message.success(this.$t('update_success'))
        this.$emit('submit')
      }).catch(() => {
        this.submitLoading = false;
      })
    }
  },
  data(){
    return {
      submitLoading:false,
      labelCol: {span: 6},
      wrapperCol: {span: 16},
      form:{},
      typeList:[],
      rules:{
        code: [
          { required: true, message: this.$t('common_please_input'), trigger: 'blur' },
        ],
        name: [
          { required: true, message: this.$t('common_please_input'), trigger: 'blur' },
        ]
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>